import { CalendarDayServiceType, IBooking } from "dataModels/b2b";
import React, { useEffect, useState } from "react";
import { Container, Row, Col } from "react-grid-system";
import styles from "views/b2bView/styles/bookingDataStyles.module.css";
import { useTranslation } from "react-i18next";
import { Button, Checkbox, Output, Select, Textarea, Textlink } from "@ds/ds-snam/react";
import { dsSelectHandler } from "shared/utils/dsComponentUtils";
import { ISelectLabel } from "@ds/ds-snam/dist/models/select";
import { AppUserGrant, AppUserRole, BadgeStatus, CalendarSlotStatus, DocumentType, DsLayout, EntityType, FormMode, IAppUserProfile, ReservationPostType, RoutePath, SnamPlantKey, SupplyingResultIdStatus, VehicleType } from "shared/constants";
import {  downloadDocument, postBooking } from "net/b2b";
import { requestPending, requestPristine } from "state/reducer/requestStatusSlice";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import MyBookingModal from "./myBookingModal";
import useAppUser from "hooks/useAppUser";
import { buildPopUp } from "components/PopUp";
import { appStore, RootState } from "state/appStore";
import { Input as TextInput } from "@ds/ds-snam/react";
import { changeStatus, getDriver, getDrivers, getVehicle, getVehicles } from "net/contracts";
import axios from "axios";
import { AppUser } from "ooAuth2/appUser";
import { IDriver, IVehicle } from "dataModels/contract";
import saveAs from "file-saver";
import BookingBioFields from "./bookingBioFields";

interface IBookingReservationDetailProps {
    bookingData: IBooking,
    edit:boolean,
    changeEditView:(arg0:FormMode)=>void
}
/** Shared component to show booking reservation detail fragment only
 * Used by booking form data and booking form review
 */
/**
 * SUPPLIYNG RESULT ID deve essere -1 fino a quando la prenotazione non si chiude,
 * poi viene settato a UNKNOWN = 5 dal BE
 * e da li parte tutta la logica
    //-1 mi arriva quando non è chiusa ma tanto non lo guardo in quel momento 
    // 5 = Valore iniziale UNKNOWN 
    // 0 = Indica se è stata chiusa con esito positivo 
    // 4 = Generic failure (Indica se è stata chiusa con esito negativo) 
        // 1 = Failure to take 
        // 2 = Failure to delivery 
        // 3 = Annullato
 */
let menuOptions_A = [
    {
        "id": "0",
        "label": "Chiuso con esito positivo",
        "value": "0",
        "selected":false
    },
    {
        "id": "1",
        "label": "Chiuso con esito negativo",
        "value": "1",
        "selected":false
    }
]
let menuOptions_B = [
    {
        "id": "1",
        "label": "Failure To Take",
        "value": "1",
        "selected":false
    },
    {
        "id": "2",
        "label": "Failure To Deliver",
        "value": "2",
        "selected":false
    },
    {
        "id": "3",
        "label": "Annullato",
        "value": "3",
        "selected":false
    }
]

const BookingReservationDetail: React.FC<IBookingReservationDetailProps> = (props): JSX.Element => {
    const { bookingData } = props;
    const { t } = useTranslation(['b2b', 'app']);
    const [formData, setFormData] = useState<IBooking>(bookingData);
    const [approvalStatus,setApprovalStatus] = useState<boolean[]>([false,false,false]); //0: driver 1:iso 2:tanker
    const [step,setStep]=useState(0);
    const [viewClosureModal,setViewClosureModal] = useState(false);
    const layoutMode = useSelector((state:RootState)=>{
        return state.dsLayout.mode;
    })
    const appUserProfile:IAppUserProfile | undefined = useAppUser()?.userProfile;
    const appUser: AppUser | undefined = useAppUser();
    const appUserRole: AppUserRole | undefined = appUser?.getRole();
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [rateSlot,setRateSlot] = useState<boolean>(false);
    const [closureSlot,setClosureSlot] = useState<boolean>(false);
    const [myApproval,setMyApproval] = useState<boolean>(false);

    const plantIdValue: string|undefined = appStore.getState().plant.plantId;

    const saveData = () => {
        postBooking(ReservationPostType.POST_CLOSE,formData)
            .then((response) => {
                buildPopUp(
                    dispatch,
                    response,
                    t,
                    t("booking.bookingForm.labels.16"), //title error
                    'OK-422', //title warning
                    t("booking.bookingForm.labels.11"), //title success
                    t("booking.bookingForm.labels.12") //description success
                )
                navigate(RoutePath.B2B_BOOKINGS_INFO);
            })
            .catch(error => {
                console.log(error);
            })
            .finally(() => {
                dispatch(requestPristine());
            })
    }

    useEffect(()=>{
        menuOptions_B =  [
            {
                "id": "1",
                "label": "Failure To Take",
                "value": "1",
                "selected":false
            },
            {
                "id": "2",
                "label": "Failure To Deliver",
                "value": "2",
                "selected":false
            },
            {
                "id": "3",
                "label": "Annullato",
                "value": "3",
                "selected":false
            }
        ];
        menuOptions_A = [
            {
                "id": "0",
                "label": "Chiuso con esito positivo",
                "value": "0",
                "selected":false
            },
            {
                "id": "1",
                "label": "Chiuso con esito negativo",
                "value": "1",
                "selected":false
            }
        ]  
    },[])

    const makeChangeStatus = (myId:string,entityType:EntityType,status:BadgeStatus) => {
        changeStatus(myId, entityType, status, '')
        .then((response) => {
            //console.log('approved')
        })
        .catch(error => {
            //console.log(error);
        })
        .finally(() => {
            dispatch(requestPristine());
        })
    }

    const approve = () => {
        if(
            (bookingData.service===CalendarDayServiceType.DRIVER_APPROVAL_TL ||
            bookingData.service===CalendarDayServiceType.SEMI_TRAILER_DRIVER_APPROVAL_TL || 
            bookingData.service===CalendarDayServiceType.ISO_CONTAINER_DRIVER_APPROVAL_TL)
            && (approvalStatus[0]===true)
        ){
            makeChangeStatus(bookingData.driverId, EntityType.DRIVER, BadgeStatus.APPROVED)
        }

        if(
            (bookingData.service===CalendarDayServiceType.ISO_CONTAINER_DRIVER_APPROVAL_TL ||
            bookingData.service===CalendarDayServiceType.ISO_CONTAINER_APPROVAL_TL) 
            && (approvalStatus[1]===true)
        ){
            makeChangeStatus(bookingData.isoContainer, EntityType.VEHICLE, BadgeStatus.APPROVED)
        }

        if(
            (bookingData.service===CalendarDayServiceType.SEMI_TRAILER_DRIVER_APPROVAL_TL ||
            bookingData.service===CalendarDayServiceType.SEMI_TRAILER_APPROVAL_TL) 
            && (approvalStatus[2]===true)
        ){
            makeChangeStatus(bookingData.tankerTruck, EntityType.VEHICLE, BadgeStatus.APPROVED)
        }
        navigate(RoutePath.B2B_BOOKINGS_INFO);
    }


    const [driverData, setDriverData] = useState<IDriver|undefined>(undefined);
    const [vehicleDataIsoContainer, setVehicleDataIsoContainer] = useState<IVehicle|undefined>(undefined);
    const [vehicleDatatankerTruck, setVehicleDatatankerTruck] = useState<IVehicle|undefined>(undefined);
    useEffect(()=>{
        if(
            (bookingData.service===CalendarDayServiceType.DRIVER_APPROVAL_TL ||
            bookingData.service===CalendarDayServiceType.SEMI_TRAILER_DRIVER_APPROVAL_TL || 
            bookingData.service===CalendarDayServiceType.ISO_CONTAINER_DRIVER_APPROVAL_TL)
        ){
            //DRIVER
            //bookingData.driverId
            if(bookingData.driverId && bookingData.driverId!==""){
            dispatch(requestPending());
                getDriver(bookingData.driverId)
                    .then((response) => {
                        setDriverData(response.data)
                    })
                    .catch((error) => {
                        console.log(error)
                    })
                    .finally(() => {
                        dispatch(requestPristine())
                    })
            }
        }

        if(
            (bookingData.service===CalendarDayServiceType.ISO_CONTAINER_DRIVER_APPROVAL_TL ||
            bookingData.service===CalendarDayServiceType.ISO_CONTAINER_APPROVAL_TL) 
        ){
            //ISO_CONTAINER
            //bookingData.isoContainer
            if(bookingData.isoContainer && bookingData.isoContainer!==""){
            dispatch(requestPending());
                getVehicle(bookingData.isoContainer)
                    .then((response) => {
                        //console.log(response)
                        setVehicleDataIsoContainer(response.data)
                    })
                    .catch((error) => {
                        console.log(error)
                    })
                    .finally(() => {
                        dispatch(requestPristine())
                    })
                }
        }

        if(
            (bookingData.service===CalendarDayServiceType.SEMI_TRAILER_DRIVER_APPROVAL_TL ||
            bookingData.service===CalendarDayServiceType.SEMI_TRAILER_APPROVAL_TL) 
        ){
            //SEMI_TRAILER/TANKER
            //bookingData.tankerTruck
            if(bookingData.tankerTruck && bookingData.tankerTruck!==""){
            dispatch(requestPending());
                getVehicle(bookingData.tankerTruck)
                    .then((response) => {
                        //console.log(response)
                        setVehicleDatatankerTruck(response.data)
                    })
                    .catch((error) => {
                        console.log(error)
                    })
                    .finally(() => {
                        dispatch(requestPristine())
                    })
                }
        }
    },[])



    const editClosureText = (closureText:string) => {
        let currentFormData = {...formData};
        currentFormData.supplyingResultNote=closureText;
        setFormData(currentFormData);
    }

    useEffect(()=>{
        if(bookingData.supplyingResultId===SupplyingResultIdStatus.POSITIVE || bookingData.supplyingResultId===SupplyingResultIdStatus.NEGATIVE){
            setStep(2);
        }
    },[])



    const [driverName, setDriverName] = React.useState<string | undefined>();
    useEffect(() => {
        const fetchDriverName = async () => {
            dispatch(requestPending());
            try {
                const [toCreditDrivers, creditedDrivers] = await axios.all([
                    getDrivers(BadgeStatus.TO_CREDIT),
                    getDrivers(BadgeStatus.CREDITED),
                ]);
                const driverList = {
                    [BadgeStatus.TO_CREDIT]: toCreditDrivers,
                    [BadgeStatus.CREDITED]: creditedDrivers,
                };
                let foundDriver = "";
                // Search in TO_CREDIT
                driverList[BadgeStatus.TO_CREDIT].forEach((driver: { driverId: any; firstName: any; lastName: any; }) => {
                    if (bookingData.driverId === driver.driverId) {
                        foundDriver = `${driver.firstName} ${driver.lastName}`;
                    }
                });
                // Search in CREDITED
                driverList[BadgeStatus.CREDITED].forEach((driver: { driverId: any; firstName: any; lastName: any; }) => {
                    if (bookingData.driverId === driver.driverId) {
                        foundDriver = `${driver.firstName} ${driver.lastName}`;
                    }
                });
                
                //setDriverName(foundDriver || undefined);

                //NB TODO: vedere cosa succede nella preselect se ho un driverId cancellato, e quindi non lo trovo poi nella select se faccio "EDIT" della prenotazione
                if(bookingData.driverId!=="" && foundDriver!==""){
                    setDriverName(foundDriver);
                }
                if(bookingData.driverId!=="" && foundDriver===""){
                    setDriverName(`${bookingData.driverFirstName} ${bookingData.driverLastName}` /*+ t('booking.bookingData.details.14')*/);
                }
                if(bookingData.driverId===""){
                    setDriverName("-");
                }

                //setDriverName(foundDriver || ("Driver with ID " + bookingData.driverId.toString() + " was assigned and then delited")); //se il driverId esiste ma non trovo il driver in elenco, significa che è stato eliminato, e quindi mostro l'ID
            } catch (error) {
                console.error(error);
            } finally {
                dispatch(requestPristine());
            }
        };
    
        fetchDriverName();
    }, [bookingData.driverId]);

    const convertVehicle = async (id: string,labelIfDeleted:string): Promise<string | undefined> => {
        dispatch(requestPending());
        try {
            const [toCreditVehicles, creditedVehicles] = await axios.all([
                getVehicles(BadgeStatus.TO_CREDIT),
                getVehicles(BadgeStatus.CREDITED),
            ]);
            const vehicleList = {
                [BadgeStatus.TO_CREDIT]: toCreditVehicles,
                [BadgeStatus.CREDITED]: creditedVehicles,
            };
            let foundVehicle = "";
    
            // Search in TO_CREDIT
            vehicleList[BadgeStatus.TO_CREDIT].forEach((vehicle: { vehicleId: any; licencePlate: any; }) => {
                if (id === vehicle.vehicleId) {
                    foundVehicle = vehicle.licencePlate;
                }
            });
    
            // Search in CREDITED
            vehicleList[BadgeStatus.CREDITED].forEach((vehicle: { vehicleId: any; licencePlate: any; }) => {
                if (id === vehicle.vehicleId) {
                    foundVehicle = vehicle.licencePlate;
                }
            });
    

            if(id!=="" && foundVehicle!==""){
                return(foundVehicle);
            }
            if(id!=="" && foundVehicle===""){
                return(bookingData[labelIfDeleted as keyof IBooking]+"" /*+ t('booking.bookingData.details.14')*/);
                //return("Vehicle with ID " + id + " was assigned and then delited");

            }
            if(id===""){
                return("-");
            }

        } catch (error) {
            console.error(error);
            return undefined;
        } finally {
            dispatch(requestPristine());
        }
    };
    const [flatBedName, setFlatBedName] = React.useState<string | undefined>();
    const [truckTractorName, setTruckTractorName] = React.useState<string | undefined>();
    const [tankerTruckName, setTankerTruckName] = React.useState<string | undefined>();
    const [isoContainerName, setIsoContainerName] = React.useState<string | undefined>();
    useEffect(() => {
        const fetchFlatBedName = async () => {
            if (bookingData.flatBed) {
                const name = await convertVehicle(bookingData.flatBed,"flatBedPlate");
                setFlatBedName(name);
            }
        };

        fetchFlatBedName();
    }, [bookingData.flatBed]);
    useEffect(() => {
        const fetchTruckTractorName = async () => {
            if (bookingData.truckTractor) {
                const name = await convertVehicle(bookingData.truckTractor,"truckTractorPlate");
                setTruckTractorName(name);
            }
        };
    
        fetchTruckTractorName();
    }, [bookingData.truckTractor]);
    useEffect(() => {
        const fetchTankerTruckName = async () => {
            if (bookingData.tankerTruck) {
                const name = await convertVehicle(bookingData.tankerTruck,"tankerTruckPlate");
                setTankerTruckName(name);
            }
        };
    
        fetchTankerTruckName();
    }, [bookingData.tankerTruck]);
    useEffect(() => {
        const fetchIsoContainerName = async () => {
            if (bookingData.isoContainer) {
                const name = await convertVehicle(bookingData.isoContainer,"isoContainerPlate");
                setIsoContainerName(name);
            }
        };
    
        fetchIsoContainerName();
    }, [bookingData.isoContainer]);
    
    return bookingData ?
        <><Container className={styles.dataContainer} style={{marginBottom:'20px' ,background: layoutMode===DsLayout.DARK_MODE?"#081C3E":"white"}}>
            
            <Row>
                <Col xs={12} md={11}>
                    <div className="formSubTitle" style={{ marginBottom: "24px" }}>
                        {t('booking.bookingData.headers.8')}
                    </div>
                </Col>
                <Col xs={12} md={1} >
                    {
                    (
                        ( 
                            props.edit && appUserProfile?.reservationGrants.includes(AppUserGrant.EDIT) 
                        ||
                            (
                                (appUserRole===AppUserRole.ADMIN||appUserRole===AppUserRole.TL_MANAGER || appUserRole===AppUserRole.BAY_OPERATOR || appUserRole===AppUserRole.CUSTOMER|| appUserRole===AppUserRole.CARRIER|| appUserRole===AppUserRole.SALES_PROFILE)
                                &&bookingData.status!==CalendarSlotStatus.CANCELLED
                                &&bookingData.status!==CalendarSlotStatus.SLOT_DELETED
                            )
                        )
                    && 
                        bookingData.status!==CalendarSlotStatus.VACANT 
                    )
                    
                    &&
                        <div style={{width:'fit-content',float:'right'}}>
                            <Button
                                buttonType="button"
                                buttonUIVariant="secondary"
                                buttonSize="medium"
                                buttonLabel=""
                                buttonIcon="icon-edit-2"
                                isDisabled={false}
                                buttonAriaLabel="deny button"
                                onClick={()=>{props.changeEditView(FormMode.EDIT)}}
                            ></Button>
                        </div>
                    }
                </Col>
            </Row>
            <Row>
                {/* servizio */}
                <Col className={styles.dataContainerColumn}>
                    <Output
                        outputTitle={t('booking.bookingData.headers.9')}
                        outputText={t("calendarSettingsForm.fields."+bookingData.service)}
                        style={{marginBottom:'16px'}}
                    ></Output>
                    {/*<div style={{color: layoutMode===DsLayout.DARK_MODE?"white":"#444C55"}}>{t('booking.bookingData.headers.9')}</div>
                    <div style={{color: layoutMode===DsLayout.DARK_MODE?"white":"black"}}>{t("calendarSettingsForm.fields."+bookingData.service)}</div>*/}
                </Col>
                {/* fornitore */}
                <Col className={styles.dataContainerColumn}>
                    <Output
                        outputTitle={t('booking.bookingData.headers.10')}
                        outputText={bookingData.shipperName?bookingData.shipperName:'-'}
                        style={{marginBottom:'16px'}}
                    ></Output>
                    {/*<div style={{color: layoutMode===DsLayout.DARK_MODE?"white":"#444C55"}}>{t('booking.bookingData.headers.10')}</div>
                    <div style={{color: layoutMode===DsLayout.DARK_MODE?"white":"black"}}>{bookingData.shipperName}</div>*/}
                </Col>
                {/* trasportatore */}
                <Col className={styles.dataContainerColumn}>
                    <Output
                        outputTitle={t('booking.bookingData.headers.26')}
                        outputText={bookingData.transporterName ? (bookingData.transporterDeleted?(bookingData.transporterName/*+ t('booking.bookingData.details.14')*/):bookingData.transporterName) : '-'}
                        style={{marginBottom:'16px'}}
                    ></Output>
                    {/*<div style={{color: layoutMode===DsLayout.DARK_MODE?"white":"#444C55"}}>{t('booking.bookingData.headers.10')}</div>
                    <div style={{color: layoutMode===DsLayout.DARK_MODE?"white":"black"}}>{bookingData.shipperName}</div>*/}
                </Col>
                <Col>
                </Col>
            </Row>

            <Row>
                {/* trattore */}
                {bookingData.truckTractor!=="" ? <Col className={styles.dataContainerColumn}>
                    <Output
                        outputTitle={t('booking.bookingData.headers.11')}
                        outputText= {truckTractorName?truckTractorName:'-'}// {bookingData.truckTractor}
                        style={{marginBottom:'16px'}}
                    ></Output>
                    {/*<div style={{color: layoutMode===DsLayout.DARK_MODE?"white":"#444C55"}}>{t('booking.bookingData.headers.11')}</div>
                    <div style={{color: layoutMode===DsLayout.DARK_MODE?"white":"black"}}>{bookingData.truckTractor}</div>*/}
                </Col>
                :
                <></>
                }
                
                {/* autobotte */}
                {bookingData.tankerTruck!=="" ? <Col className={styles.dataContainerColumn}>
                    <Output
                        outputTitle={t('booking.bookingData.headers.12')}
                        outputText={tankerTruckName?tankerTruckName:'-'}//{bookingData.tankerTruck}
                        style={{marginBottom:'16px'}}
                    ></Output>
                    {/*<div style={{color: layoutMode===DsLayout.DARK_MODE?"white":"#444C55"}}>{t('booking.bookingData.headers.12')}</div>
                    <div style={{color: layoutMode===DsLayout.DARK_MODE?"white":"black"}}>{bookingData.tankerTruck}</div>*/}
                </Col>
                :
                <></>}

                {/* isoContainer */}
                {bookingData.isoContainer!=="" ? <Col className={styles.dataContainerColumn}>
                    <Output
                        outputTitle={t('Iso Container')}
                        outputText={isoContainerName?isoContainerName:'-'}//{bookingData.isoContainer}
                        style={{marginBottom:'16px'}}
                    ></Output>
                    {/*<div style={{color: layoutMode===DsLayout.DARK_MODE?"white":"#444C55"}}>{t('booking.bookingData.headers.12')}</div>
                    <div style={{color: layoutMode===DsLayout.DARK_MODE?"white":"black"}}>{bookingData.tankerTruck}</div>*/}
                </Col>:<></>}

                {/* flatBed */}
                {bookingData.flatBed!=="" ? <Col className={styles.dataContainerColumn}>
                    <Output
                        outputTitle={t('Flat Bed')}
                        outputText={flatBedName?flatBedName:'-'}//{bookingData.flatBed}
                        style={{marginBottom:'16px'}}
                    ></Output>
                    {/*<div style={{color: layoutMode===DsLayout.DARK_MODE?"white":"#444C55"}}>{t('booking.bookingData.headers.12')}</div>
                    <div style={{color: layoutMode===DsLayout.DARK_MODE?"white":"black"}}>{bookingData.tankerTruck}</div>*/}
                </Col>:<></>}
            </Row>

            <br />
            <Row>
                {/* autista */}
                <Col className={styles.dataContainerColumn}>
                    <Output
                        outputTitle={t('booking.bookingData.headers.13')}
                        outputText= {driverName?driverName:'-'}// {bookingData.driverId}
                        style={{marginBottom:'16px'}}
                    ></Output>
                    {/*<div style={{color: layoutMode===DsLayout.DARK_MODE?"white":"#444C55"}}>{t('booking.bookingData.headers.13')}</div>
                    <div style={{color: layoutMode===DsLayout.DARK_MODE?"white":"black"}}>{bookingData.driverId}</div>*/}
                </Col>
                {/* baia */}
                <Col className={styles.dataContainerColumn}>
                    <Output
                        outputTitle={t('booking.bookingData.headers.14')}
                        outputText = {`${bookingData.bay ? `${bookingData.bay} - ${bookingData.forcedBay !== "-1" ? t('booking.bookingData.headers.27') : t('booking.bookingData.headers.28')}` : '-'}`}
                        style={{marginBottom:'16px'}}
                    ></Output>
                    {/*<div style={{color: layoutMode===DsLayout.DARK_MODE?"white":"#444C55"}}>{t('booking.bookingData.headers.14')}</div>
                    <div style={{color: layoutMode===DsLayout.DARK_MODE?"white":"black"}}>{bookingData.bay}</div>*/}
                </Col>
                {plantIdValue===SnamPlantKey.PIGNATARO &&
                    <>
                        {/* quantity */}
                        {/*<Col className={styles.dataContainerColumn}>
                            <Output
                                outputTitle={t("booking.bookingForm.labels.27")}
                                outputText = {bookingData.preventiveQuantity?bookingData.preventiveQuantity.toString()+" ton":"-"}
                                style={{marginBottom:'16px'}}
                            ></Output>
                        </Col>*/}
                        {/* energy */}
                        <Col className={styles.dataContainerColumn}>
                            <Output
                                outputTitle={t("booking.bookingForm.labels.28")}
                                outputText = {bookingData.preventiveEnergy?bookingData.preventiveEnergy.toString()+" MWh":"-"}
                                style={{marginBottom:'16px'}}
                            ></Output>
                        </Col>
                        <Col className={styles.dataContainerColumn}>
                        </Col>
                    </>
                }
            </Row>

            <BookingBioFields bookingData={bookingData} />

            <Row>
               <Col className={styles.dataContainerColumn}>
                    <Output
                        outputTitle={t('booking.bookingData.headers.40')}
                        outputText = {bookingData.finalBusiness?bookingData.finalBusiness:'-'}
                        style={{marginBottom:'16px'}}
                    ></Output>
                </Col> 
            </Row>


            <Row>
                {/* ind. destinazione */}
                <Col className={styles.dataContainerColumn}>
                    <Output
                        outputTitle={t('booking.bookingData.headers.15')}
                        outputText={bookingData.destinationAddress?bookingData.destinationAddress:'-'}
                        style={{marginBottom:'16px'}}
                    ></Output>
                    {/*<div style={{color: layoutMode===DsLayout.DARK_MODE?"white":"#444C55"}}>{t('booking.bookingData.headers.15')}</div>
                    <div style={{color: layoutMode===DsLayout.DARK_MODE?"white":"black"}}>{bookingData.destinationAddress}</div>*/}
                </Col>
                {/* st number */}
                <Col className={styles.dataContainerColumn}>
                    <Output
                        outputTitle={t('booking.bookingData.headers.22')}
                        outputText= {bookingData.destinationStreetNumber?bookingData.destinationStreetNumber:'-'}// 
                        style={{marginBottom:'16px'}}
                    ></Output>
                    {/*<div style={{color: layoutMode===DsLayout.DARK_MODE?"white":"#444C55"}}>{t('booking.bookingData.headers.13')}</div>
                    <div style={{color: layoutMode===DsLayout.DARK_MODE?"white":"black"}}>{bookingData.driverId}</div>*/}
                </Col>
                {/* naz. destinazione */}
                <Col className={styles.dataContainerColumn}>
                    <Output
                        outputTitle={t('booking.bookingData.headers.16')}
                        outputText={bookingData.destinationNation?bookingData.destinationNation:'-'}
                        style={{marginBottom:'16px'}}
                    ></Output>
                    {/*<div style={{color: layoutMode===DsLayout.DARK_MODE?"white":"#444C55"}}>{t('booking.bookingData.headers.16')}</div>
                    <div style={{color: layoutMode===DsLayout.DARK_MODE?"white":"black"}}>{bookingData.destinationNation}</div>*/}
                </Col>

                {/* provincia */}
                <Col className={styles.dataContainerColumn}>
                    <Output
                        outputTitle={t('booking.bookingData.headers.23')}
                        outputText= {bookingData.destinationProvince?bookingData.destinationProvince:'-'}//
                        style={{marginBottom:'16px'}}
                    ></Output>
                    {/*<div style={{color: layoutMode===DsLayout.DARK_MODE?"white":"#444C55"}}>{t('booking.bookingData.headers.13')}</div>
                    <div style={{color: layoutMode===DsLayout.DARK_MODE?"white":"black"}}>{bookingData.driverId}</div>*/}
                </Col>
                
            </Row>
            <Row>

                
                {/* città */}
                <Col className={styles.dataContainerColumn}>
                    <Output
                        outputTitle={t('booking.bookingData.headers.24')}
                        outputText= {bookingData.destinationCity?bookingData.destinationCity:'-'}//
                        style={{marginBottom:'16px'}}
                    ></Output>
                    {/*<div style={{color: layoutMode===DsLayout.DARK_MODE?"white":"#444C55"}}>{t('booking.bookingData.headers.13')}</div>
                    <div style={{color: layoutMode===DsLayout.DARK_MODE?"white":"black"}}>{bookingData.driverId}</div>*/}
                </Col>
                {/* postal code*/}
                <Col className={styles.dataContainerColumn}>
                    <Output
                        outputTitle={t('booking.bookingData.headers.25')}
                        outputText= {bookingData.destinationPostalCode?bookingData.destinationPostalCode:'-'}//
                        style={{marginBottom:'16px'}}
                    ></Output>
                    {/*<div style={{color: layoutMode===DsLayout.DARK_MODE?"white":"#444C55"}}>{t('booking.bookingData.headers.13')}</div>
                    <div style={{color: layoutMode===DsLayout.DARK_MODE?"white":"black"}}>{bookingData.driverId}</div>*/}
                </Col>



                {/* Business name - Codice fiscale*/}
                <Col className={styles.dataContainerColumn}>
                    <Output
                        outputTitle={t('booking.bookingData.headers.29')}
                        outputText= {bookingData.destinationBusinessName?bookingData.destinationBusinessName:'-'}//
                        style={{marginBottom:'16px'}}
                    ></Output>
                    {/*<div style={{color: layoutMode===DsLayout.DARK_MODE?"white":"#444C55"}}>{t('booking.bookingData.headers.13')}</div>
                    <div style={{color: layoutMode===DsLayout.DARK_MODE?"white":"black"}}>{bookingData.driverId}</div>*/}
                </Col>
                {/* VAT - P.iva*/}
                <Col className={styles.dataContainerColumn}>
                    <Output
                        outputTitle={t('booking.bookingData.headers.30')}
                        outputText= {bookingData.destinationVat?bookingData.destinationVat:'-'}//
                        style={{marginBottom:'16px'}}
                    ></Output>
                    {/*<div style={{color: layoutMode===DsLayout.DARK_MODE?"white":"#444C55"}}>{t('booking.bookingData.headers.13')}</div>
                    <div style={{color: layoutMode===DsLayout.DARK_MODE?"white":"black"}}>{bookingData.driverId}</div>*/}
                </Col>
            </Row>















            <br />



            {bookingData.secondaryDestination && bookingData.secondaryDestination.length > 0 && (
            bookingData.secondaryDestination.map((secondary, index) => (<>
                <Row key={index} style={{marginTop:'35px'}}>
                    {/* Address */}
                    <Col className={styles.dataContainerColumn}>
                        <Output
                        outputTitle={`${t('booking.bookingData.headers.15')} ${index + 2}`}
                        outputText={secondary.destinationAddress || '-'}
                        style={{ marginBottom: '16px' }}
                        />
                    </Col>

                    {/* str number */}
                    <Col className={styles.dataContainerColumn}>
                        <Output
                        outputTitle={`${t('booking.bookingData.headers.22')} ${index + 2}`}
                        outputText={secondary.destinationStreetNumber || '-'}
                        style={{ marginBottom: '16px' }}
                        />
                    </Col>
                    {/* Stato */}
                    <Col className={styles.dataContainerColumn}>
                        <Output
                        outputTitle={`${t('booking.bookingData.headers.16')} ${index + 2}`}
                        outputText={secondary.destinationNation || '-'}
                        style={{ marginBottom: '16px' }}
                        />
                    </Col>

                    {/* Provincia */}
                    <Col className={styles.dataContainerColumn}>
                        <Output
                        outputTitle={`${t('booking.bookingData.headers.23')} ${index + 2}`}
                        outputText={secondary.destinationProvince || '-'}
                        style={{ marginBottom: '16px' }}
                        />
                    </Col>
                </Row>
                <Row key={index}>
                    {/* Città */}
                    <Col className={styles.dataContainerColumn}>
                        <Output
                        outputTitle={`${t('booking.bookingData.headers.24')} ${index + 2}`}
                        outputText={secondary.destinationCity || '-'}
                        style={{ marginBottom: '16px' }}
                        />
                    </Col>
                    {/* CAP */}
                    <Col className={styles.dataContainerColumn}>
                        <Output
                        outputTitle={`${t('booking.bookingData.headers.25')} ${index + 2}`}
                        outputText={secondary.destinationPostalCode || '-'}
                        style={{ marginBottom: '16px' }}
                        />
                    </Col>
                    <Col className={styles.dataContainerColumn}>
                    <Output
                        outputTitle={`${t('booking.bookingData.headers.29')} ${index + 2}`}
                        outputText={secondary.destinationBusinessName || '-'}
                        style={{ marginBottom: '16px' }}
                        />
                    </Col>
                    <Col className={styles.dataContainerColumn}>
                    <Output
                        outputTitle={`${t('booking.bookingData.headers.30')} ${index + 2}`}
                        outputText={secondary.destinationVat || '-'}
                        style={{ marginBottom: '16px' }}
                        />
                    </Col>
                </Row></>
            ))
            )}

            <Row style={{marginTop:'35px'}}>
                {/* naz. percorsa */}
                {bookingData.crossedNation.length!==0 && <Col md={3} className={styles.dataContainerColumn}>
                    <Output
                        outputTitle={t('booking.bookingData.headers.17')}
                        outputText={bookingData.crossedNation.length!==0?bookingData.crossedNation.join(", "):'-'}
                        style={{marginBottom:'16px'}}
                    ></Output>
                    {/*<div style={{color: layoutMode===DsLayout.DARK_MODE?"white":"#444C55"}}>{t('booking.bookingData.headers.17')}</div>
                    <div style={{color: layoutMode===DsLayout.DARK_MODE?"white":"black"}}>{bookingData.crossedNation.join(", ")}</div>*/}
                </Col>}
                {/* tempo destinazione */}
                
                {bookingData.typeVehicle===VehicleType.ISO_CONTAINER && <Col md={3} className={styles.dataContainerColumn}>
                    <Output
                        outputTitle={t('booking.bookingData.headers.18')}
                        outputText={bookingData.destinationTime +" h"}
                        style={{marginBottom:'16px'}}
                    ></Output>
                    {/*<div style={{color: layoutMode===DsLayout.DARK_MODE?"white":"#444C55"}}>{t('booking.bookingData.headers.18')}</div>
                    <div style={{color: layoutMode===DsLayout.DARK_MODE?"white":"black"}}>{bookingData.destinationTime} h</div>*/}
                </Col>}

            </Row>


















            { (plantIdValue===SnamPlantKey.PIGNATARO && bookingData.dailyGasPrice!==null && bookingData.dailyGasPrice!==undefined) &&
                <>
                   <Row>
                        <Col xs={12} md={11}>
                            <div className="formSubTitle" style={{ marginBottom: "24px",marginTop:"24px",fontSize: '20px' }}>
                                {t('booking.bookingData.headers.38')}
                            </div>
                        </Col>
                    </Row>
                    <Row>
                        <>
                            {/* GAS PRICE*/}
                            <Col md={3} className={styles.dataContainerColumn}>
                                <Output
                                    outputTitle={t('booking.bookingData.headers.39')}
                                    outputText={
                                        (bookingData.dailyGasPrice!==null && bookingData.dailyGasPrice!==undefined ) ? 
                                            bookingData.dailyGasPrice?.toString() 
                                        : 
                                            "-"
                                    } 
                                    style={{marginBottom:'16px'}}
                                ></Output>
                            </Col>
                        </>
                    </Row>
                </>
            }



            {(
            (
                bookingData.status===CalendarSlotStatus.CLOSED &&
                bookingData.closedLoadMass!==null && bookingData.closedLoadEnergy!==null
            ) && (!rateSlot))
            &&
                <>
                    <Row>
                        <Col xs={12} md={11}>
                            <div className="formSubTitle" style={{ marginBottom: "24px",marginTop:"24px",fontSize: '20px' }}>
                                {t('booking.bookingData.headers.19')}
                            </div>
                        </Col>
                    </Row>
                    <Row>
                        <>
                            {/* Quantità caricata */}
                            <Col md={3} className={styles.dataContainerColumn}>
                                <Output
                                    outputTitle={t('booking.bookingData.headers.20')}
                                    outputText={bookingData.closedLoadMass + " kg"} 
                                    style={{marginBottom:'16px'}}
                                ></Output>
                                {/*<div style={{color: layoutMode===DsLayout.DARK_MODE?"white":"#444C55"}}>{t('booking.bookingData.headers.20')}</div>
                                <div style={{color: layoutMode===DsLayout.DARK_MODE?"white":"black"}}>{bookingData.closedLoadEnergy} MWh</div>*/}
                            </Col>
                            {/* Energia caricata */}
                            <Col md={3} className={styles.dataContainerColumn}>
                                <Output
                                    outputTitle={t('booking.bookingData.headers.21')}
                                    outputText={bookingData.closedLoadEnergy +" MWh"}
                                    style={{marginBottom:'16px'}}
                                ></Output>
                                {/*<div style={{color: layoutMode===DsLayout.DARK_MODE?"white":"#444C55"}}>{t('booking.bookingData.headers.21')}</div>
                                <div style={{color: layoutMode===DsLayout.DARK_MODE?"white":"black"}}>{bookingData.closedLoadMass} m³/ton</div>*/}
                            </Col>
                        </>
                    </Row>
                </>
            }






            










            
























            
            {(
            (
                bookingData.supplyingResultId===SupplyingResultIdStatus.POSITIVE ||
                bookingData.supplyingResultId===SupplyingResultIdStatus.FTT || 
                bookingData.supplyingResultId===SupplyingResultIdStatus.FTD || 
                bookingData.supplyingResultId===SupplyingResultIdStatus.CANCELED || 
                bookingData.supplyingResultId===SupplyingResultIdStatus.NEGATIVE
            )  && ( !rateSlot))
            
            &&
                <div style={{marginTop:'30px'}}>                
                    <Row>
                        <Col>
                            <div className="formSubTitle" style={{ marginBottom: "24px",marginTop:"24px",fontSize: '20px' }}>
                                {t("booking.bookingData.details.0")} {/*Esito finale slot*/}
                            </div>
                        </Col>
                    </Row>
                    <Row>
                        <Col md={3} className={styles.dataContainerColumn}>
                            <Output
                                outputTitle={t("booking.bookingData.details.0")}
                                outputText={bookingData.supplyingResultId===SupplyingResultIdStatus.POSITIVE?t("booking.bookingData.details.11"):t("booking.bookingData.details.12")} 
                                style={{marginBottom:'16px'}}
                            ></Output>
                            {/*<div style={{color: layoutMode===DsLayout.DARK_MODE?"white":"#444C55"}}>{t("booking.bookingData.details.0")}</div>
                            <div style={{color: layoutMode===DsLayout.DARK_MODE?"white":"black"}}>{bookingData.supplyingResultId===SupplyingResultIdStatus.POSITIVE?t("booking.bookingData.details.11"):t("booking.bookingData.details.12")}</div>*/}
                        </Col>
                    </Row>
                </div>
            }
            {(
            (
                bookingData.supplyingResultId===SupplyingResultIdStatus.FTT || 
                bookingData.supplyingResultId===SupplyingResultIdStatus.FTD || 
                bookingData.supplyingResultId===SupplyingResultIdStatus.CANCELED
            )  && (!closureSlot && !rateSlot))
                &&
                <div style={{marginTop:'15px'}}>
                    <Row>
                        <Col>
                            <div className="formSubTitle" style={{ marginBottom: "24px",marginTop:"24px",fontSize: '20px' }}>
                                {t("booking.bookingData.details.1")}
                            </div>
                        </Col>
                    </Row>
                    <Row>
                        <Col md={3} className={styles.dataContainerColumn}>
                            <Output
                                outputTitle={t("booking.bookingData.details.2")}
                            ></Output>
                            {bookingData.supplyingResultId===SupplyingResultIdStatus.FTT && <Output
                                outputText="Failure To Take"
                            ></Output>}
                            {bookingData.supplyingResultId===SupplyingResultIdStatus.FTD && <Output
                                outputText="Failure To Deliver"
                            ></Output>}
                            {bookingData.supplyingResultId===SupplyingResultIdStatus.CANCELED && <Output
                                outputText={t("booking.bookingData.details.10")}
                            ></Output>}
                            {/*<div style={{color: layoutMode===DsLayout.DARK_MODE?"white":"#444C55"}}>{t("booking.bookingData.details.2")}</div>
                            {bookingData.supplyingResultId===SupplyingResultIdStatus.FTT && <div style={{color: layoutMode===DsLayout.DARK_MODE?"white":"black"}}>Failure To Take</div>}
                            {bookingData.supplyingResultId===SupplyingResultIdStatus.FTD && <div style={{color: layoutMode===DsLayout.DARK_MODE?"white":"black"}}>Failure To Deliver</div>}
                            {bookingData.supplyingResultId===SupplyingResultIdStatus.CANCELED && <div style={{color: layoutMode===DsLayout.DARK_MODE?"white":"black"}}>{t("booking.bookingData.details.10")}</div>}
                            */}
                            </Col>
                    </Row>
                </div>
            }
             {(
            (
                bookingData.status===CalendarSlotStatus.CLOSED &&
                bookingData.closedLoadMass!==null && bookingData.closedLoadEnergy!==null
            ) && (!rateSlot))
            &&
                <> 
                <div style={{marginTop:'12px'}}>                
                    <Row>
                        <Col> 
                            <div className="column" style={{ float: "left" }}>
                                <Textlink
                                    textlinkText={
                                        t("booking.bookingData.details.23")
                                    }
                                    textlinkTextSize="SMALL"
                                    isRouterLink={true}
                                    onClickLink={() => {
                                        downloadDocument(
                                            bookingData.codeIup!,
                                            plantIdValue === SnamPlantKey.PANIGAGLIA ? EntityType.TMAC_DDT : EntityType.PENTASCADA_DDT,
                                            plantIdValue === SnamPlantKey.PANIGAGLIA ? DocumentType.TMAC_DDT_DOC : DocumentType.PENTASCADA_DDT_DOC
                                        )
                                            .then((response) => {
                                                let file = new File(
                                                    [response.data],
                                                    // eslint-disable-next-line no-useless-concat
                                                    "DDT" + ".pdf"
                                                );
                                                saveAs(file);
                                            })
                                            .catch((error) => {
                                                console.log(error);
                                            });
                                    }}
                                />
                            </div>
                    </Col></Row></div>
                
                </>
            }

            






            <div style={{marginTop:'15px'}}>
                {
                    (
                        (
                            (
                                bookingData.service===CalendarDayServiceType.DRIVER_APPROVAL_TL || 
                                bookingData.service===CalendarDayServiceType.ISO_CONTAINER_DRIVER_APPROVAL_TL || 
                                bookingData.service===CalendarDayServiceType.SEMI_TRAILER_DRIVER_APPROVAL_TL
                            )
                            && driverData!==undefined
                            && bookingData.driverId!==""
                            && (driverData?.isApproved === true)
                        )
                        ||
                        (
                            (
                                bookingData.service===CalendarDayServiceType.ISO_CONTAINER_APPROVAL_TL ||
                                bookingData.service===CalendarDayServiceType.ISO_CONTAINER_DRIVER_APPROVAL_TL
                            ) 
                            && vehicleDataIsoContainer!==undefined
                            && bookingData.isoContainer!==""
                            && (vehicleDataIsoContainer?.isApproved === true)
                        )
                        ||
                        (
                            (
                                bookingData.service===CalendarDayServiceType.SEMI_TRAILER_DRIVER_APPROVAL_TL ||
                                bookingData.service===CalendarDayServiceType.SEMI_TRAILER_APPROVAL_TL
                            ) 
                            && vehicleDatatankerTruck!==undefined
                            && bookingData.tankerTruck!==""
                            && (vehicleDatatankerTruck?.isApproved === true)
                        )
                    ) &&
                    <Row>
                        <Col>
                            <div className="formSubTitle" style={{ marginBottom: "12px",marginTop:"24px",fontSize: '20px' }}>
                                {t("booking.bookingData.details.16")}
                            </div>
                        </Col>
                    </Row>
                }
                {
                    (bookingData.status===CalendarSlotStatus.CLOSED && 
                        (
                            (
                                bookingData.service===CalendarDayServiceType.DRIVER_APPROVAL_TL || 
                                bookingData.service===CalendarDayServiceType.ISO_CONTAINER_DRIVER_APPROVAL_TL || 
                                bookingData.service===CalendarDayServiceType.SEMI_TRAILER_DRIVER_APPROVAL_TL
                            )
                            && driverData!==undefined
                            && bookingData.driverId!==""
                            && (driverData?.isApproved === true)
                        )
                    ) ?
                        <Row>
                            <Col md={3} className={styles.dataContainerColumn}>
                                <Output
                                    outputText={t("booking.bookingData.details.17")}
                                ></Output>
                            </Col>
                        </Row>
                    :
                        <>
                            {/*
                                (
                                    (
                                        bookingData.service===CalendarDayServiceType.DRIVER_APPROVAL_TL || 
                                        bookingData.service===CalendarDayServiceType.ISO_CONTAINER_DRIVER_APPROVAL_TL || 
                                        bookingData.service===CalendarDayServiceType.SEMI_TRAILER_DRIVER_APPROVAL_TL
                                    )
                                    && driverData!==undefined
                                    && bookingData.driverId!==""
                                    && !(driverData?.isApproved === true)
                                ) &&
                                    <Row>
                                        <Col md={3} className={styles.dataContainerColumn}>
                                            <Output
                                                outputText={t("booking.bookingData.details.20")}
                                            ></Output>
                                        </Col>
                                </Row>
                            */}
                        </>
                }
                {
                    (
                        bookingData.status===CalendarSlotStatus.CLOSED && 
                        (
                            (
                                bookingData.service===CalendarDayServiceType.ISO_CONTAINER_APPROVAL_TL ||
                                bookingData.service===CalendarDayServiceType.ISO_CONTAINER_DRIVER_APPROVAL_TL
                            ) 
                            && vehicleDataIsoContainer!==undefined
                            && bookingData.isoContainer!==""
                            && (vehicleDataIsoContainer?.isApproved === true)
                        )
                    ) ?
                        <Row>
                            <Col md={3} className={styles.dataContainerColumn}>
                                <Output
                                    outputText={t("booking.bookingData.details.18")}
                                ></Output>
                            </Col>
                        </Row>
                    :
                        <>
                            {/*
                                (
                                    (
                                        bookingData.service===CalendarDayServiceType.ISO_CONTAINER_APPROVAL_TL ||
                                        bookingData.service===CalendarDayServiceType.ISO_CONTAINER_DRIVER_APPROVAL_TL
                                    )
                                    && vehicleDataIsoContainer!==undefined
                                    && bookingData.isoContainer!==""
                                    && !(vehicleDataIsoContainer?.isApproved === true)
                                ) &&
                                    <Row>
                                        <Col md={3} className={styles.dataContainerColumn}>
                                            <Output
                                                outputText={t("booking.bookingData.details.21")}
                                            ></Output>
                                        </Col>
                                    </Row>
                            */}
                        </>
                }
                {
                    (
                        bookingData.status===CalendarSlotStatus.CLOSED && 
                        (
                            (
                                bookingData.service===CalendarDayServiceType.SEMI_TRAILER_DRIVER_APPROVAL_TL ||
                                bookingData.service===CalendarDayServiceType.SEMI_TRAILER_APPROVAL_TL
                            ) 
                            && vehicleDatatankerTruck!==undefined
                            && bookingData.tankerTruck!==""
                            && (vehicleDatatankerTruck?.isApproved === true)
                        )
                    ) ?
                        <Row>
                            <Col md={3} className={styles.dataContainerColumn}>
                                <Output
                                    outputText={t("booking.bookingData.details.19")}
                                ></Output>
                            </Col>
                        </Row>
                    :
                        <>
                            {/*
                                (
                                    (
                                        bookingData.service===CalendarDayServiceType.SEMI_TRAILER_DRIVER_APPROVAL_TL ||
                                        bookingData.service===CalendarDayServiceType.SEMI_TRAILER_APPROVAL_TL
                                    )
                                    && vehicleDatatankerTruck!==undefined
                                    && bookingData.tankerTruck!==""
                                    && !(vehicleDatatankerTruck?.isApproved === true)
                                ) &&
                                <Row>
                                    <Col md={3} className={styles.dataContainerColumn}>
                                        <Output
                                            outputText={t("booking.bookingData.details.22")}
                                        ></Output>
                                    </Col>
                                </Row>
                            */}
                        </>
                }
            </div>
            


        </Container>






            {(
                bookingData.status===CalendarSlotStatus.CLOSED && 
                appUserProfile?.reservationGrants.includes(AppUserGrant.RATE_SLOT) && 
                !closureSlot && 
                !rateSlot &&
                !myApproval &&
                formData.supplyingResultId!==SupplyingResultIdStatus.NEGATIVE //se è negativo voglio che prima inserisca la chiusura, dopo puo modificare il tutto
            ) &&
            <Button
                style={{ marginLeft: '10px', marginTop: '20px' ,float:'left'}}
                id="backButton"
                buttonType="button"
                buttonUIVariant="secondary"
                buttonSize="medium"
                buttonLabel={t('booking.bookingData.headers.33')}
                buttonIcon=""
                isDisabled={false}
                onClickEvent={() => {
                    setRateSlot(true)
                }}
            />
            }
            {(
                bookingData.status===CalendarSlotStatus.CLOSED && 
                appUserProfile?.reservationGrants.includes(AppUserGrant.CLOSE_SLOT) && 
                !rateSlot && 
                !closureSlot && 
                !myApproval &&
                formData.supplyingResultId===SupplyingResultIdStatus.NEGATIVE // lo vedo solo se la chiusura è negativa
            ) &&
            <Button
                style={{marginLeft: '10px', marginTop: '20px' ,float:'left'}}
                id="backButton"
                buttonType="button"
                buttonUIVariant="secondary"
                buttonSize="medium"
                buttonLabel={t('booking.bookingData.headers.34')}
                buttonIcon=""
                isDisabled={false}
                onClickEvent={() => {
                      setClosureSlot(true)
                }}
            />
            }
            {(
                bookingData.status===CalendarSlotStatus.CLOSED && 
                (appUserProfile?.reservationGrants.includes(AppUserGrant.RATE_SLOT)||appUserProfile?.reservationGrants.includes(AppUserGrant.CLOSE_SLOT)) && 
                !closureSlot && 
                !rateSlot &&
                !myApproval &&
                (
                    bookingData.service===CalendarDayServiceType.DRIVER_APPROVAL_TL || 
                    bookingData.service===CalendarDayServiceType.ISO_CONTAINER_DRIVER_APPROVAL_TL || 
                    bookingData.service===CalendarDayServiceType.SEMI_TRAILER_DRIVER_APPROVAL_TL ||
                    bookingData.service===CalendarDayServiceType.ISO_CONTAINER_APPROVAL_TL ||
                    bookingData.service===CalendarDayServiceType.SEMI_TRAILER_APPROVAL_TL
                )

                && 
                (
                    (
                        (
                            bookingData.service===CalendarDayServiceType.DRIVER_APPROVAL_TL || 
                            bookingData.service===CalendarDayServiceType.ISO_CONTAINER_DRIVER_APPROVAL_TL || 
                            bookingData.service===CalendarDayServiceType.SEMI_TRAILER_DRIVER_APPROVAL_TL
                        )
                        && driverData!==undefined
                        &&
                        bookingData.driverId!==""
                        &&
                        !(driverData?.isApproved === true)
                    )
                    ||
                    (
                        (
                            bookingData.service===CalendarDayServiceType.ISO_CONTAINER_APPROVAL_TL ||
                            bookingData.service===CalendarDayServiceType.ISO_CONTAINER_DRIVER_APPROVAL_TL
                        )&&
                        vehicleDataIsoContainer!==undefined
                        &&
                        bookingData.isoContainer!==""
                        &&
                        !(vehicleDataIsoContainer?.isApproved === true)
                    )
                    ||
                    (
                        (
                            bookingData.service===CalendarDayServiceType.SEMI_TRAILER_DRIVER_APPROVAL_TL ||
                            bookingData.service===CalendarDayServiceType.SEMI_TRAILER_APPROVAL_TL
                        )&&
                        vehicleDatatankerTruck!==undefined
                        &&
                        bookingData.tankerTruck!==""
                        &&
                        !(vehicleDatatankerTruck?.isApproved === true)
                    )
                )
            ) &&
            <Button
                style={{ marginLeft: '10px', marginTop: '20px',float:'left' }}
                id="backButton"
                buttonType="button"
                buttonUIVariant="secondary"
                buttonSize="medium"
                buttonLabel={t('booking.bookingData.headers.35')}
                buttonIcon=""
                isDisabled={false}
                onClickEvent={() => {
                    setMyApproval(true);
                }}
            />
            }

            {rateSlot &&
                <>
                    <div className="box" style={{ marginTop: '20px', background: layoutMode===DsLayout.DARK_MODE?"#081C3E":"var(--Neutrali-50, #EFF1F5)" }}>
                        <div className="boxTitle" style={{ fontSize: '25px',color:layoutMode===DsLayout.DARK_MODE?"white":"black"  }}>
                            {t("booking.bookingData.details.13")}
                        </div>
                        <Row style={{ marginBottom: "12px"}}>
                            <Col xs={12} md={4}>
                                <TextInput
                                    inputLabel={t('booking.bookingData.headers.20')} //quantità caricata
                                    inputValue={formData.closedLoadMass!==null&&formData.closedLoadMass!==undefined?formData.closedLoadMass.toString():""}
                                    inputName="quantityLoaded"
                                    inputId="quantityLoaded"
                                    inputDescription="kg"
                                    inputStatus="default"
                                    inputPlaceholder=""
                                    isDisabled={false}
                                    input-event-type="single_character"
                                    isNumberVariant={true} //STRINGTOONLYNUMBER
                                    isReadonly={false}
                                    onInputChange={(inputEvent: Event)=>{
                                        const fieldName = "closedLoadMass";
                                        let currentData: IBooking = {...formData};
                                        if((inputEvent as CustomEvent).detail.input.value!==""){
                                            (currentData[fieldName as keyof IBooking] as number) = Number((inputEvent as CustomEvent).detail.input.value);
                                        }else{
                                            (currentData[fieldName as keyof IBooking] as number|null) = null;
                                        }
                                        setFormData(currentData);
                                    }}
                                />
                            </Col>
                            <Col xs={12} md={4}>
                                <TextInput
                                    inputLabel={t('booking.bookingData.headers.21')} //Energia caricata
                                    inputValue={formData.closedLoadEnergy!==null&&formData.closedLoadEnergy!==undefined?formData.closedLoadEnergy.toString():""}
                                    inputName="energyLoaded"
                                    inputId="energyLoaded"
                                    inputDescription="MWh"
                                    inputStatus="default"
                                    inputPlaceholder=""
                                    isDisabled={false}
                                    input-event-type="single_character"
                                    isNumberVariant={true} //STRINGTOONLYNUMBER
                                    isReadonly={false}
                                    onInputChange={(inputEvent: Event)=>{
                                        const fieldName = "closedLoadEnergy";
                                        let currentData: IBooking = {...formData};
                                        if((inputEvent as CustomEvent).detail.input.value!==""){
                                            (currentData[fieldName as keyof IBooking] as number|null) = Number((inputEvent as CustomEvent).detail.input.value);
                                        }else{
                                            (currentData[fieldName as keyof IBooking] as number|null) = null;
                                        }
                                        setFormData(currentData);
                                    }}
                                />
                            </Col>
                        </Row>
                    </div>
                    <div className="box" style={{ marginTop: '20px', background: layoutMode===DsLayout.DARK_MODE?"#081C3E":"var(--Neutrali-50, #EFF1F5)" }}>
                            <div className="boxTitle" style={{ fontSize: '25px',color:layoutMode===DsLayout.DARK_MODE?"white":"black"  }}>
                                {t("booking.bookingData.details.3")}
                            </div>
                            <Row style={{ marginBottom: "12px" }}>
                                <Col xs={12} md={4}>
                                <Select
                                    id={'id-select-supplingResult_1'}
                                    menuPlaceholder={t("booking.bookingForm.labels.10")}
                                    hasIcon={false}
                                    menuOptions={menuOptions_A === undefined ? [] : menuOptions_A} 
                                    menuLabel={t("booking.bookingData.details.4")}
                                    menuId="select-id"
                                    isDisabled={menuOptions_A === undefined}
                                    selectStatus="default"
                                    onOptionSelection={(event: Event) => {
                                        //console.log((event as CustomEvent).detail.option.value);
                                        let selection = Number((event as CustomEvent).detail.option.value)
                                        if(selection===0){
                                            let currentFormData = {...formData};
                                            currentFormData.supplyingResultId=selection;
                                            setFormData(currentFormData);
                                        }else{
                                            let currentFormData = {...formData};
                                            currentFormData.supplyingResultId=SupplyingResultIdStatus.NEGATIVE;
                                            setFormData(currentFormData);
                                        }
                                        const selectedOption = (event as CustomEvent).detail.option;
                                        dsSelectHandler(menuOptions_A as ISelectLabel[], selectedOption);
                                    }}
                                ></Select>
                                </Col>
                            </Row>
                    </div>
                    <Button
                        style={{ float: 'right', marginLeft: '10px', marginTop: '20px' }}
                        id="backButton"
                        buttonType="button"
                        buttonUIVariant="primary"
                        buttonSize="medium"
                        buttonLabel={t('general.buttons.save', { ns: 'app' })}//"Salva"
                        buttonIcon=""
                        isDisabled={
                            (formData.closedLoadMass===null || 
                            formData.closedLoadEnergy===null || 
                            formData.supplyingResultId===SupplyingResultIdStatus.UNKNOWN) ||
                            (menuOptions_A[0].selected===false &&
                            menuOptions_A[1].selected===false)
                        }
                        onClickEvent={() => {
                            if(formData.supplyingResultId===SupplyingResultIdStatus.POSITIVE){ //POSITIVO
                                //Primo step del final slot outcome
                                //approve() //faccio eventualmente la approve dei componenti da approvare se mi trovo in un service che lo permette
                                saveData() //salvo poi i dati
                            }else if(formData.supplyingResultId===SupplyingResultIdStatus.NEGATIVE){ //NEGATIVO
                                //Primo step del final slot outcome
                                //approve() //faccio eventualmente la approve dei componenti da approvare se mi trovo in un service che lo permette
                                setViewClosureModal(true); //salvo poi i dati
                            }
                        }}
                    />
                </>
            }

            {closureSlot &&
                <>
                    <div className="box" style={{ marginTop: '20px', background: layoutMode===DsLayout.DARK_MODE?"#081C3E":"var(--Neutrali-50, #EFF1F5)" }}>
                    <div className="boxTitle" style={{ fontSize: '25px',color:layoutMode===DsLayout.DARK_MODE?"white":"black" }}>
                        {t("booking.bookingData.details.1")}
                    </div>
                    <Row style={{ marginBottom: "12px" }}>
                        <Col xs={12} md={4}>
                        <Select
                            id={'id-select-supplingResult_1'}
                            menuPlaceholder={t("booking.bookingForm.labels.10")}/*"Seleziona"*/
                            hasIcon={false}
                            menuOptions={menuOptions_B === undefined ? [] : menuOptions_B} //TODO
                            menuLabel={t("booking.bookingData.details.5")}
                            menuId="select-id"
                            isDisabled={menuOptions_B === undefined}
                            selectStatus="default"
                            onOptionSelection={(event: Event) => {
                                //console.log((event as CustomEvent).detail.option.value);
                                const selectedOption = (event as CustomEvent).detail.option;
                                let currentFormData = {...formData};
                                currentFormData.supplyingResultId=Number(selectedOption.value);
                                setFormData(currentFormData);
                                dsSelectHandler(menuOptions_B as ISelectLabel[], selectedOption);
                            }}
                        ></Select>
                        </Col>
                    </Row>
                </div>
                <Button
                        style={{ float: 'right', marginLeft: '10px', marginTop: '20px' }}
                        id="backButton"
                        buttonType="button"
                        buttonUIVariant="primary"
                        buttonSize="medium"
                        buttonLabel={t('general.buttons.save', { ns: 'app' })}//"Salva"
                        buttonIcon=""
                        isDisabled={
                            formData.supplyingResultId!==SupplyingResultIdStatus.FTT && 
                            formData.supplyingResultId!==SupplyingResultIdStatus.FTD && 
                            formData.supplyingResultId!==SupplyingResultIdStatus.CANCELED &&
                            menuOptions_B[0].selected===false &&
                            menuOptions_B[1].selected===false &&
                            menuOptions_B[2].selected===false
                        }
                        onClickEvent={() => {
                            //console.log(formData);
                            if( formData.supplyingResultId===SupplyingResultIdStatus.FTT||formData.supplyingResultId===SupplyingResultIdStatus.FTD||formData.supplyingResultId===SupplyingResultIdStatus.CANCELED){
                                //qui salvo FTT,FTD o ANNULLATO
                                saveData();
                            }
                        }}
                    />
                </>
            }

{appUserProfile?.reservationGrants.includes(AppUserGrant.RATE_SLOT) &&
                (bookingData.status===CalendarSlotStatus.CLOSED 
                    /*&& bookingData.supplyingResultId===SupplyingResultIdStatus.UNKNOWN && 
                    (
                    formData.supplyingResultId===SupplyingResultIdStatus.UNKNOWN||
                    formData.supplyingResultId===SupplyingResultIdStatus.NEGATIVE || 
                    formData.supplyingResultId===SupplyingResultIdStatus.POSITIVE
                    )*/
                   && myApproval
                
                )  
                && (bookingData.service===CalendarDayServiceType.DRIVER_APPROVAL_TL || 
                    bookingData.service===CalendarDayServiceType.ISO_CONTAINER_DRIVER_APPROVAL_TL || 
                    bookingData.service===CalendarDayServiceType.SEMI_TRAILER_DRIVER_APPROVAL_TL ||
                    bookingData.service===CalendarDayServiceType.ISO_CONTAINER_APPROVAL_TL ||
                    bookingData.service===CalendarDayServiceType.SEMI_TRAILER_APPROVAL_TL
                ) &&
                <>
                    <div className="box" style={{ marginTop: '20px', background: layoutMode===DsLayout.DARK_MODE?"#081C3E":"var(--Neutrali-50, #EFF1F5)" }}>
                    <div className="boxTitle" style={{ fontSize: '25px',color:layoutMode===DsLayout.DARK_MODE?"white":"black" }}>
                        {"Approval"}
                    </div>
                    <Row style={{marginTop:'16px'}}>
                        {/* Driver Approval */}
                        {
                        ((
                            bookingData.service===CalendarDayServiceType.DRIVER_APPROVAL_TL || 
                            bookingData.service===CalendarDayServiceType.ISO_CONTAINER_DRIVER_APPROVAL_TL || 
                            bookingData.service===CalendarDayServiceType.SEMI_TRAILER_DRIVER_APPROVAL_TL
                        ) &&
                        bookingData.driverId!==null&&bookingData.driverId!==undefined&&bookingData.driverId!==''
                        &&
                         !(driverData?.isApproved === true)
                        )&&
                        <Col md={3} className={styles.dataContainerColumn}>
                            <Checkbox
                                checkboxId="DriverApproval"
                                checkboxStatus="default"
                                checkboxLabel="Approve Driver"
                                elementResetPair=""
                                isDisabled={false}
                                isChecked={approvalStatus[0]}
                                isRequired={false}
                                onCheckboxChange={(event:Event)=>{
                                    let currentApprovalStatus = approvalStatus;
                                    currentApprovalStatus[0] = (event as CustomEvent).detail.checkbox.checked;
                                    setApprovalStatus(currentApprovalStatus);
                                }}>
                            </Checkbox>
                        </Col>}
                        {/* Iso Container Approval */}
                        {((
                            bookingData.service===CalendarDayServiceType.ISO_CONTAINER_APPROVAL_TL ||
                            bookingData.service===CalendarDayServiceType.ISO_CONTAINER_DRIVER_APPROVAL_TL
                        ) &&
                        bookingData.isoContainer!==null&&bookingData.isoContainer!==undefined&&bookingData.isoContainer!==''
                        &&
                            !(vehicleDataIsoContainer?.isApproved === true)
                        )&&
                        <Col md={3} className={styles.dataContainerColumn}>
                            <Checkbox
                                checkboxId="DriverApproval"
                                checkboxStatus="default"
                                checkboxLabel="Approve Iso Container"
                                elementResetPair=""
                                isDisabled={false}
                                isChecked={approvalStatus[1]}
                                isRequired={false}
                                onCheckboxChange={(event:Event)=>{
                                    let currentApprovalStatus = approvalStatus;
                                    currentApprovalStatus[1] = (event as CustomEvent).detail.checkbox.checked;
                                    setApprovalStatus(currentApprovalStatus);
                                }}>
                            </Checkbox>
                        </Col>}
                        {/* Semi trailer Approval */}
                        {((
                            bookingData.service===CalendarDayServiceType.SEMI_TRAILER_APPROVAL_TL || 
                            bookingData.service===CalendarDayServiceType.SEMI_TRAILER_DRIVER_APPROVAL_TL
                        ) &&
                        bookingData.tankerTruck!==null&&bookingData.tankerTruck!==undefined&&bookingData.tankerTruck!==''
                        &&
                            !(vehicleDatatankerTruck?.isApproved === true)
                        )&&
                        <Col md={3} className={styles.dataContainerColumn}>
                            <Checkbox
                                checkboxId="DriverApproval"
                                checkboxStatus="default"
                                checkboxLabel="Approve Tunker Truck"
                                elementResetPair=""
                                isDisabled={false}
                                isChecked={approvalStatus[2]}
                                isRequired={false}
                                onCheckboxChange={(event:Event)=>{
                                    let currentApprovalStatus = approvalStatus;
                                    currentApprovalStatus[2] = (event as CustomEvent).detail.checkbox.checked;
                                    setApprovalStatus(currentApprovalStatus);
                                }}>
                            </Checkbox>
                        </Col>}
                    </Row>
                    </div>
                </>
            }
            {myApproval &&
                <>
                <Button
                        style={{ float: 'right', marginLeft: '10px', marginTop: '20px' }}
                        id="backButton"
                        buttonType="button"
                        buttonUIVariant="primary"
                        buttonSize="medium"
                        buttonLabel={t('general.buttons.save', { ns: 'app' })}//"Salva"
                        buttonIcon=""
                        isDisabled={false}
                        onClickEvent={() => {
                            approve();
                        }}
                    />
                </>
            }







        {viewClosureModal &&
            <MyBookingModal type={'closureModal'} onClose={()=>setViewClosureModal(false)} saveData={saveData} editClosureText={editClosureText}/>
        }
        </>
        :
        <></>
}
export default BookingReservationDetail;